/** @format */

import { TypedUseSelectorHook, useSelector } from "react-redux";
import { RootState } from "../redux/reducers/index";

const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default useAppSelector;
